import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { LcPoolSummary } from '../hooks/useLiquidityCachePools';

interface PoolCardProps {
  pool: LcPoolSummary;
}

export function PoolCard({ pool }: PoolCardProps) {
  const navigate = useNavigate();

  const price =
    BigInt(pool.reserveA) > 0n && BigInt(pool.reserveB) > 0n
      ? (Number(pool.reserveB) / Number(pool.reserveA)).toFixed(4)
      : 'N/A';

  const hasExternal = pool.tokenA.source === 'external' || pool.tokenB.source === 'external';

  return (
    <Card
      className="cursor-pointer hover:border-primary/50 transition-colors"
      onClick={() => navigate(`/a/arche_liquidity_caches/${pool.poolId}`)}
    >
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">{pool.name}</CardTitle>
          {hasExternal && <SimulatedBadge />}
        </div>
        <p className="text-sm text-muted-foreground">
          {pool.tokenA.symbol} / {pool.tokenB.symbol}
        </p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>
            <p className="text-muted-foreground">TVL</p>
            <p className="font-medium">
              {pool.reserveA} {pool.tokenA.symbol} + {pool.reserveB} {pool.tokenB.symbol}
            </p>
          </div>
          <div>
            <p className="text-muted-foreground">Price</p>
            <p className="font-medium">
              1 {pool.tokenA.symbol} = {price} {pool.tokenB.symbol}
            </p>
          </div>
          <div>
            <p className="text-muted-foreground">Fee</p>
            <p className="font-medium">{(pool.feeBps / 100).toFixed(2)}%</p>
          </div>
          <div>
            <p className="text-muted-foreground">LP Shares</p>
            <p className="font-medium">{pool.totalLpShares}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function SimulatedBadge() {
  return (
    <Badge variant="outline" className="text-xs">
      Simulated
    </Badge>
  );
}
